import { render, staticRenderFns } from "./additionInfo.vue?vue&type=template&id=7ce05c1e&scoped=true"
import script from "./additionInfo.vue?vue&type=script&lang=js"
export * from "./additionInfo.vue?vue&type=script&lang=js"
import style0 from "./additionInfo.vue?vue&type=style&index=0&id=7ce05c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce05c1e",
  null
  
)

export default component.exports